import { useQuery } from '@tanstack/react-query';
import { Card } from '@projexn/ui';
import { api } from '../lib/api';

interface TenantUser {
  userId: string;
  email: string;
  name: string | null;
  role: string;
  status: string;
}

export function AdminPage() {
  const usersQ = useQuery({
    queryKey: ['tenant-users'],
    queryFn: () => api.get<TenantUser[]>('/api/tenant/users'),
  });

  return (
    <div className="space-y-4">
      <header>
        <h1 className="text-xl font-semibold">Team</h1>
        <p className="text-sm text-zinc-500">Members of this tenant.</p>
      </header>

      <Card className="divide-y divide-zinc-200">
        {usersQ.isLoading ? (
          <p className="p-6 text-sm text-zinc-500">Loading…</p>
        ) : usersQ.isError ? (
          <p className="p-6 text-sm text-red-700">{(usersQ.error as Error).message}</p>
        ) : (usersQ.data ?? []).length === 0 ? (
          <p className="p-6 text-sm text-zinc-500">No members yet.</p>
        ) : (
          (usersQ.data ?? []).map((u) => (
            <div key={u.userId} className="flex items-center justify-between px-4 py-3">
              <div>
                <p className="text-sm font-medium">{u.name ?? u.email}</p>
                <p className="text-xs text-zinc-500">{u.email}</p>
              </div>
              <div className="flex items-center gap-3 text-xs">
                <span className="rounded bg-zinc-100 px-2 py-0.5">{u.role}</span>
                <span className="rounded bg-zinc-100 px-2 py-0.5">{u.status}</span>
              </div>
            </div>
          ))
        )}
      </Card>
    </div>
  );
}
